import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Foundation Website coming soon.
          <br />Stay tuned.
        </p>
      </header>
    </div>
  );
}

export default App;
